import React from 'react';
import PropTypes from 'prop-types';
import IndexTablePagerItem from './IndexTablePagerItem';

export default class IndexTablePager extends React.Component {

    static propTypes = {
        currentPage: PropTypes.number.isRequired,
        pages: PropTypes.number.isRequired,
        advancedNavigation: PropTypes.bool,
        navigationArrows: PropTypes.bool
    }

    static defaultProps = {
        advancedNavigation: true,
        navigationArrows: true
    }

    navigateToPage = page => {
        this.props.onNavigateToPageClick(page)
    }

    render() {
        return (
            <div className="index-table-pager">
                {this.props.advancedNavigation && (
                    <IndexTablePagerItem active={this.isBackwardNavigationActive()}
                                         onClick={() => this.navigateToPage(0)} advanced={true}>
                        {__('First page')}
                    </IndexTablePagerItem>
                )}

                {this.props.navigationArrows && (
                    this.renderBackwardNavigationArrow()
                )}

                {this.renderPagesNavigator()}

                {this.props.navigationArrows && (
                    this.renderForwardNavigationArrow()
                )}

                {this.props.advancedNavigation && (
                    <IndexTablePagerItem active={this.isForwardNavigationActive()}
                                         onClick={() => this.navigateToPage(this.props.pages - 1)} advanced={true}>
                        {__('Last page')}
                    </IndexTablePagerItem>
                )}
            </div>
        )
    }

    renderBackwardNavigationArrow() {
        const click = () => {
            this.navigateToPage(this.props.currentPage - 1)
        }

        return (
            <IndexTablePagerItem onClick={click} active={this.isBackwardNavigationActive()}>
                {__('<')}
            </IndexTablePagerItem>
        )
    }

    renderForwardNavigationArrow() {
        const click = () => {
            this.navigateToPage(this.props.currentPage + 1)
        }

        return (
            <IndexTablePagerItem onClick={click} active={this.isForwardNavigationActive()}>
                {__('>')}
            </IndexTablePagerItem>
        )
    }

    isBackwardNavigationActive() {
        return this.props.currentPage > 0
    }

    isForwardNavigationActive() {
        return this.props.currentPage < this.props.pages - 1
    }

    renderPagesNavigator() {
        let pages = []

        let startPage = 0
        let endPage = 0

        if (this.props.pages > 3) {
            startPage = this.props.currentPage - 1
            endPage = this.props.currentPage + 1
        } else {
            startPage = 0
            endPage = this.props.pages - 1
        }

        if (startPage < 0) {
            startPage = 0
            endPage += 1
        }

        if (endPage > this.props.pages - 1) {
            startPage -= 1
            endPage = this.props.pages - 1
        }

        for (let i = startPage; i <= endPage; i++) {
            const isSelected = (i === this.props.currentPage)

            pages.push(
                <IndexTablePagerItem key={i} onClick={() => this.navigateToPage(i)} selected={isSelected}>
                    {i + 1}
                </IndexTablePagerItem>
            )
        }

        return pages
    }
}